import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
// import { numberToMillons } from 'src/utils/functions';
import Loading from 'src/components/global/Loading';

interface MesaDeControlContent {
  content: {
    data: any;
  };
  spinner,
  channel: string,
}

const MesaDeControl: FC<MesaDeControlContent> = ({
  content, spinner, channel
}) => {
  const title = 'Mesa de Control';
  return (
    <Box>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic colSpan={1}>&nbsp;</TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={3}>
                  Aprobado
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={3}>
                  Rechazado
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={3}>
                  Observado
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={3}>
                  Pendiente
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center" colSpan={2}>
                  Total Número
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                {channel !== 'usuario'
                  ? <TableCellHeaderBasic>Canal</TableCellHeaderBasic>
                  : <TableCellHeaderBasic>Usuario</TableCellHeaderBasic>}
                <TableCellHeaderBasic align="right">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Monto
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Monto
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Monto
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  Monto
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  <br />
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                  spinner && (
                    <TableRow>
                      <TableCell colSpan={15}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
              {!spinner && content.data.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index}>
                  <TableCell>{item.nombreComercial}</TableCell>
                  <TableCell align="center">
                    {item.aprobado_numero}
                  </TableCell>
                  <TableCell align="center">
                    {item.aprobado_monto.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell align="center">
                    {item.aprobado_porcentaje}
                    &nbsp;%
                  </TableCell>
                  <TableCell align="center">
                    {item.rechazado_numero}
                  </TableCell>
                  <TableCell align="center">
                    {item.rechazado_monto.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell align="center">
                    {item.rechazado_porcentaje}
                    &nbsp;%
                  </TableCell>
                  <TableCell align="center">
                    {item.observado_numero}
                  </TableCell>
                  <TableCell align="center">
                    {item.observado_monto.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell align="center">
                    {item.observado_porcentaje}
                    &nbsp;%
                  </TableCell>
                  <TableCell align="center">
                    {item.pendiente_numero}
                  </TableCell>
                  <TableCell align="center">
                    {item.pendiente_monto.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell align="center">
                    {item.pendiente_porcentaje}
                    &nbsp;%
                  </TableCell>
                  <TableCell align="center">
                    {item.total}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default MesaDeControl;
